import Header from "components/Header";
import React, { FC, ReactNode } from "react";
import ResponsiveDrawer from "../Drawer";

interface DrawerLayoutProps {
  children: ReactNode;
  crumbs?: { text: string; link?: string }[];
  expandable?: boolean;
}

const DrawerLayout: FC<DrawerLayoutProps> = ({
  children,
  crumbs,
  expandable,
}) => {
  return (
    <div className="flex h-screen max-h-screen w-full overflow-hidden bg-themed-background pr-[var(--ai-panel-width)] font-manrope transition-[padding-right] duration-200 ease-out">
      <ResponsiveDrawer expandable={expandable} />
      <div
        className={`flex h-screen max-h-screen min-w-0 flex-1 flex-col bg-themed-background ${
          expandable ? "pl-[58px]" : ""
        }`}
      >
        <Header crumbs={crumbs || []} />
        <main className="min-h-0 min-w-0 flex-1 overflow-y-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DrawerLayout;
